import api from './api';

/**
 * Abre um arquivo enviado ao sistema (currículo, comprovante) numa nova aba.
 * Os arquivos exigem token, então são baixados como blob; links externos antigos
 * (comprovantes informados como URL) abrem direto.
 */
export async function openUploadedFile(path: string): Promise<void> {
    if (/^https?:\/\//i.test(path)) {
        window.open(path, '_blank', 'noopener');
        return;
    }
    const response = await api.get(`/api/uploads/${path}`, { responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
